import { render, staticRenderFns } from "./floorShareList.vue?vue&type=template&id=52b9e655&scoped=true"
import script from "./floorShareList.vue?vue&type=script&lang=js"
export * from "./floorShareList.vue?vue&type=script&lang=js"
import style0 from "./floorShareList.vue?vue&type=style&index=0&id=52b9e655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9e655",
  null
  
)

export default component.exports